export default __webpack_public_path__ + "static/media/icon-embed-link.64c3260b.svg";